import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const sliderBlock = () => {
    new Swiper( '.swiper-slider-block', {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 8,
        speed: 800,
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
        },
        navigation: {
            nextEl: '.swiper-slider-block-next',
            prevEl: '.swiper-slider-block-prev',
        },
        breakpoints: {
            1024: {
                spaceBetween: 20,
            },
            1280: {
                spaceBetween: 48,
            },
        },
    } );
};

export { sliderBlock as default };
